/**
 * Dosya adlarını normalleştirmeye yönelik yardımcı fonksiyonlar
 */

/**
 * Türkçe karakterleri İngilizce karşılıklarıyla değiştirir
 *
 * @param {string} text - Normalleştirilecek metin
 * @returns {string} - Normalleştirilmiş metin
 */
export const normalizeText = (text) => {
  if (!text) return ''

  // Türkçe karakter haritası
  const charMap = {
    'ç': 'c', 'Ç': 'C',
    'ğ': 'g', 'Ğ': 'G',
    'ı': 'i', 'İ': 'I',
    'ö': 'o', 'Ö': 'O',
    'ş': 's', 'Ş': 'S',
    'ü': 'u', 'Ü': 'U',
  }

  // Unicode normalleştirme ve ardından Türkçe karakterleri değiştirme
  return text
      .replace(/[çÇğĞıİöÖşŞüÜ]/g, match => charMap[match] || match)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Aksanlı karakterleri temizle
      .replace(/[^a-zA-Z0-9_\-. ]/g, '') // Sadece güvenli karakterleri tut
}

/**
 * Dosya adını normalleştirir, uzantıyı korur
 *
 * @param {string} fileName - Normalleştirilecek dosya adı
 * @returns {string} - Normalleştirilmiş dosya adı
 */
export const normalizeFileName = (fileName) => {
  if (!fileName) return ''

  const lastDotIndex = fileName.lastIndexOf('.')
  if (lastDotIndex === -1) {
    // Uzantı yoksa tüm metni normalleştir
    return normalizeText(fileName)
  }

  // Dosya adını ve uzantıyı ayır
  const baseName = fileName.substring(0, lastDotIndex)
  const extension = fileName.substring(lastDotIndex)

  // Dosya adını normalleştir, uzantıyı koru
  return normalizeText(baseName) + extension
}

/**
 * File nesnesini normalleştirilmiş isimle klonlar
 *
 * @param {File} file - Orijinal dosya nesnesi
 * @returns {File} - Normalleştirilmiş isimli yeni dosya nesnesi
 */
export const normalizeFile = (file) => {
  if (!file) return null

  // Dosya adını normalleştir
  const normalizedFileName = normalizeFileName(file.name)

  // Yeni bir File nesnesi oluştur
  return new File(
      [file],
      normalizedFileName,
      { type: file.type },
  )
}